import { Component, OnInit, Input, Inject } from '@angular/core';

import { filter, Subscription } from 'rxjs';

import { PreferencesModel } from '../../../../../Core/Users/models/preferences.model';
import { CurrentUserStateService } from '../../../../../Core/Users/services/current-user-state.service';

import { Mention } from '../../../../Mentions/models/mention';
import { KeywordHighlightModel } from '../../../../Misc/models/keyword-highlight.model';
import { MediaTypeEnum } from '../../../../Basic/enums/media-type.enum';
import { MentionSearchVarsService } from '../../../services/mention-search-vars.service';
@Component({
    selector: 'agpr-social-post-article',
    templateUrl: './social-post-article.component.html',
    styleUrls: ['./social-post-article.component.scss'],
    standalone: false
})
export class SocialPostArticleComponent implements OnInit {

    @Input() mention: Mention;

    preferences: PreferencesModel;
    dateFormat: string;

    bodyParagraphs: string[] = [];
    highlightKeywords: KeywordHighlightModel[] = [];

    private subscriptions: Subscription[] = [];

    readonly mediaTypeEnum = MediaTypeEnum;

    constructor(
        protected currentUserStateService: CurrentUserStateService,
        @Inject('SocialSearchService') private socialSearchService: MentionSearchVarsService,
    ) {}

    ngOnInit(): void {
        this.bodyParagraphs = (this.mention.body || '').split('\n\n');

        this.subscriptions.push(
            this.currentUserStateService.getPreferences().pipe(filter(x => !!x)).subscribe(prefs => {
                this.preferences = prefs;
                this.dateFormat = prefs.getDateFormatString(true, true, true);
            }),
            this.socialSearchService.getHighlightKeywords().subscribe(
                highlightKeywords => {
                    this.highlightKeywords = highlightKeywords;
                }
            )
        );
    }
}
